module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAAxklEQVQ4T9XUPQoCMRCG4fdTwQNopWIr9oLewsK/0kvY23oJS0HQ0sYLWYjaiavNSGBXUi3sYKFpQiDzZJIZIjObAA9JB9JhZgOgla0LzJKZGXCVVI/AHTAuAH22BvCSgp0IXANDF+gJyovR74NmVgVM0it6wwpQ9mQfipIAZ0ntCNwAIy8Y2uYmqfattgntkUg6RmAPaDgy1B9U2XGt3JBQ5T1wlzSP3nAB9B2HlbLP4SSpGYFbYOYACeASeEpaReAU6HrAN/91VqsiZ+tsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map/more.png
// module id = V+sK
// module chunks = 2